import React, { Component, PropTypes } from 'react'
import { Loading } from '../misc'
import { formHandler, Button, Select } from '../ui'

import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import * as locationActions from '../../actions/location'
import * as personalActions from '../../actions/personal'

class AdditionalCitySelectionForm extends Component {
    static propTypes = {
        appState: PropTypes.object.isRequired,
        country: PropTypes.string.isRequired,
        crewUUID: PropTypes.string.isRequired,
        data: PropTypes.object,
        location: PropTypes.object.isRequired,
        locationActions: PropTypes.object.isRequired,
        modalHook: PropTypes.func.isRequired,
        personal: PropTypes.object.isRequired,
        personalActions: PropTypes.object.isRequired,
        useRegions: PropTypes.bool.isRequired,
    }

    constructor(props) {
        super(props)

        this.state = { data: this.props.data }

        this._updateValue = formHandler.updateValue.bind(this)
    }

    componentWillMount() {
        // If we have no regions, load them in
        if (this.props.useRegions && (! this.props.location.regions) && this.props.country) {
            this.props.locationActions.loadRegions(this.props.country)
        }

        if (this.props.modalHook) {
            this.props.modalHook({
                title: 'Add new city',
                footerActions: {
                    right: (
                        <Button
                            buttonOnly
                            loading={ this.props.appState.loading }
                            onClick={ this._submitCity }
                            status="primary"
                        >
                            Save
                        </Button>
                    ),
                },
            })
        }
    }

    _updateRegion = (data) => {
        // when updating the region, invalidate the currently-selected city
        data.city = null

        this._updateValue(data)

        this.props.locationActions.clearCities()
    }

    _searchCity = (query) => {
        this.props.locationActions.loadCities(this.props.country, this.state.data.region, query)
    }

    _submitCity = () => {
        this.props.personalActions.submitAdditionalCity(
            { city: this.state.data.city },
            this.props.crewUUID,
            this.state.data.uuid
        )
    }

    render() {
        if (! this.props.location.regions.length) {
            return <Loading />
        }

        const errors = this.props.personal.additional_city_errors

        let regionSelection = null

        if (this.props.useRegions) {
            regionSelection = (
                <Select
                    error={ errors.region }
                    name="region"
                    options={ this.props.location.regions }
                    placeholder="Select state"
                    updateValue={ this._updateRegion }
                    value={ this.state.data.region }
                />
            )
        }

        let citySelectionDisabled = true

        if (this.state.data.region || ! this.props.useRegions) {
            citySelectionDisabled = false
        }

        const citySelection = (
            <Select
                disabled={ citySelectionDisabled }
                error={ errors.city }
                name="city"
                noOptionPlaceholder="Type in city name"
                options={ this.props.location.cities }
                placeholder="Select city"
                searchOptions={ this._searchCity }
                updateValue={ this._updateValue }
                value={ this.state.data.city }
            />
        )

        return (
            <div>
                { regionSelection }
                { citySelection }
            </div>
        )
    }
}

export default connect(
    (state) => {
        return {
            appState: state.appState,
            location: state.location,
            personal: state.personal,
        }
    },
    (dispatch) => {
        return {
            locationActions: bindActionCreators(locationActions, dispatch),
            personalActions: bindActionCreators(personalActions, dispatch),
        }
    }
)(AdditionalCitySelectionForm)



// WEBPACK FOOTER //
// ./app/components/personal/additional_city_selection_form.js